// Styles
import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const privacySettingsStyles = makeStyles((theme: Theme) => ({
    mainPaper: {
        display: "flex",
        flexDirection: "column",
        boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1)",
        padding: theme.spacing(2),
        borderRadius: 8,
        overflow: "auto",
    },
    rowTitle: {
        fontWeight: 600,
        fontSize: 20,
    },
    hubAccessDescription: {
        fontWeight: 500,
        color: theme.palette.secondary.main,
        marginBottom: theme.spacing(2),
    },
    infoIcon: {
        fontSize: theme.typography.pxToRem(14),
        color: theme.palette.info.main,
    },
    warningMessage: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    alert: {
        display: "flex",
        alignItems: "center",
        margin: theme.spacing(1, 0, 2),
        "& .MuiAlert-message": {
            flexGrow: 1,
        },
        "& .MuiAlert-icon": {
            display: "flex",
            alignItems: "center",
        },
    },
    warningMessageButtonsContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .accept": {
            minWidth: "auto",
            padding: theme.spacing(0, 1),
            marginLeft: theme.spacing(2),
            borderColor: "#FDFEFF",
            color: "#FDFEFF",
        },
        "& .cancel": {
            backgroundColor: "#FDFEFF",
            minWidth: "auto",
            padding: theme.spacing(0, 1),
            borderColor: "#FDFEFF",
            color: `${theme.palette.primary.dark} !important`,
        },
    },
    scrollButton: {
        borderColor: "#FDFEFF",
        color: "#FDFEFF",
    },
    textDisabledDataPrivacy: {
        display: "flex",
        color: theme.palette.error.dark,
        alignItems: "center",
        margin: theme.spacing(0, 0, 2),
        "&  .icon": {
            marginRight: theme.spacing(1),
            fontSize: 20,
        },
    },
    tooltipTitle: {
        fontSize: "20px !important",
        fontWeight: 600,
        marginLeft: theme.spacing(1),
    },
    paper: {
        boxShadow: "0px 20px 25px rgba(0, 0, 0, 0.1), 0px 10px 10px rgba(0, 0, 0, 0.04)",
        padding: theme.spacing(0.5, 2),
        backgroundColor: theme.palette.background.blue,
        width: 360,
        borderRadius: "6px",
        "& img": {
            width: "100%",
        },
        "& .MuiTypography-root": {
            fontSize: 16,
            "& span": {
                fontWeight: 600,
                textDecoration: "underline",
            },
        },
    },
    hubContainer: {
        display: "flex",
        margin: theme.spacing(2, 0),
        alignItems: "center",
    },
    footerButton: {
        color: theme.palette.secondary.main,
        textDecoration: "underline",
        textUnderlineOffset: "4px",
        padding: 0,
        minWidth: 170,
        marginLeft: theme.spacing(1),
    },
    switch: {
        "& .MuiSwitch-thumb": {
            backgroundColor: theme.palette.primary.main,
        },
        "& .Mui-disabled .MuiSwitch-thumb": {
            backgroundColor: `${theme.palette.text.disabled} !important`,
        },
        "& .Mui-disabled + .MuiSwitch-track": {
            backgroundColor: `${theme.palette.text.disabled} !important`,
            opacity: 0.5,
        },
    },
}));

export default privacySettingsStyles;
